// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","524":"app","933":"auth"}[chunkId] || chunkId) + "." + {"85":"b32d9185","370":"532b8b60","523":"1ffe7e97","524":"267cde96","573":"38cce509","933":"55d87724"}[chunkId] + ".chunk.js";
};